var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmerSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.976,
    height: 43.5,
    viewBox: "0 0 49.976 43.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_emg_sb",
    transform: "translate(4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "piin_emg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M4,0l9,21L8,29,0,10Z",
    transform: "translate(29 26) rotate(90)",
    fill: "rgba(0,0,0,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    transform: "translate(16) rotate(90)",
    fill: "#e6001c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_Counter",
    "data-name": "White Counter",
    d: "M2.5,0h27L32,4,29.5,8H2.5L0,4Z",
    transform: "translate(12 4) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stroke",
    transform: "translate(16) rotate(90)",
    fill: "none",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.554248809814453 1 L 1.179248809814453 8 L 5.554248809814453 15 L 34.44575119018555 15 L 38.82075119018555 8 L 34.44575119018555 1 L 5.554248809814453 1 M 5 0 L 35 0 L 40 8 L 35 16 L 5 16 L 0 8 L 5 0 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Map_Components_Work_Pins_Assigned_Pin_Copy_42",
    "data-name": "Map Components / Work Pins / Assigned Pin Copy 42",
    transform: "translate(11.976)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Map_Components_Pins_Assigned_Pin_background",
    "data-name": "Map Components / Pins / Assigned Pin background",
    width: 20,
    height: 32,
    transform: "translate(8.4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14_Copy",
    "data-name": "Group 14 Copy",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow-2",
    "data-name": "Shadow",
    d: "M4,0l9,21L8,29,0,10Z",
    transform: "translate(29 26) rotate(90)",
    fill: "rgba(0,0,0,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    "data-name": "Fill",
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    transform: "translate(16 0) rotate(90)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stroke-2",
    "data-name": "Stroke",
    transform: "translate(16 0) rotate(90)",
    fill: "none",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.554248809814453 1 L 1.179248809814453 8 L 5.554248809814453 15 L 34.44575119018555 15 L 38.82075119018555 8 L 34.44575119018555 1 L 5.554248809814453 1 M 5 0 L 35 0 L 40 8 L 35 16 L 5 16 L 0 8 L 5 0 Z",
    stroke: "none",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerSb);
export default __webpack_public_path__ + "static/media/emer_sb.7c64581e39ffa6e3528ff279f4f82d05.svg";
export { ForwardRef as ReactComponent };